import LockScreen from "views/pages/authentication/LockScreen"
import Login from "views/pages/authentication/Login"
import Register from "views/pages/authentication/Register"
import UserProfile from "views/pages/authentication/UserProfile"
import ForgotPassword from "views/pages/authentication/ForgotPassword"
import Error400 from "views/pages/error/Error400"
import Error500 from "views/pages/error/Error500"
import PricingStyle1 from "views/pages/pricing/PricingStyle1"
import PricingStyle2 from "views/pages/pricing/PricingStyle2"

export {
    LockScreen,
    Login,
    Register,
    UserProfile,
    Error400,
    ForgotPassword,
    Error500,
    PricingStyle1,
    PricingStyle2
}